import { createWebHistory, createRouter } from 'vue-router';

import Principal from '../screens/Principal.vue';
import Opcoes from '../screens/Opcoes.vue';
export const routes = [    
    {path:'/rtfonte', name:'rtfonte',component: Principal},    
	{path:'/rtfonte/:cod', name:'opcoes',component: Opcoes},    
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;